import { animate, style, transition, trigger } from '@angular/animations';
import { Component, OnInit, Input } from '@angular/core';
import { ComponentBase, DiscountModel, RentalInfo } from 't4core';
import { NavigationService, BookingService } from 'app-components';

@Component({
  selector: 'animated-campaign-card',
  templateUrl: './animated-campaign-card.html',
  styleUrls: ['./animated-campaign-card.css'],
  standalone: false,
  animations: [
    trigger('slideUp', [
      transition(':enter', [
        style({ transform: 'translateY(100%)', opacity: 0 }),
        animate('400ms ease-out', style({ transform: 'translateY(0)', opacity: 1 }))
      ]),
      transition(':leave', [
        animate('300ms ease-in', style({ transform: 'translateY(100%)', opacity: 0 }))
      ])
    ])
  ]
})

export class AnimatedCampaignCard extends ComponentBase implements OnInit {
  constructor(private navigator: NavigationService) {
    super();
  }
  @Input() public booking: RentalInfo;
  showBanner = false;
  actionExist = false;
  uriPath: string = "";
  

  public campaing: DiscountModel;

  async ngOnInit() {
    console.log("Init2!");
    this.campaing = await this.Api.get<DiscountModel>("Campaign/CheckActivePopupCampaign", { bookingId: this.booking?.Id ?? 0 })
    console.log(this.campaing);
    

    if (this.campaing.VoucherUri != null || this.campaing.VoucherUri != "") this.actionExist = true;

    this.triggerBanner();
  }

  triggerBanner() {
    setTimeout(() => {
      this.showBanner = true;
    }, 2000);
  }

  close() {
    this.showBanner = false;
  }


 async openAction() {
   if (this.actionExist) {
     await this.Api.get<boolean>("Campaign/OfferClicked", { discountId: this.campaing?.DiscountId ?? 0})
      await window.open(this.campaing.VoucherUri, '_blank');
    }
  }

  navigateToOffer() {
    this.showBanner = false;
    this.navigator.navigateToView('MyPage.Campaigns');
    
  }

}
